import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectUserData } from 'src/app/store/selectors/auth.selectors';
import { IUserData } from 'src/app/utils/interfaces/auth.interfaces';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';

@UntilDestroy()
@Component({
  selector: 'xpac-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  private static readonly DEFAULT_HEADER_TITLE: string = 'Portal';
  private static readonly DEFAULT_HEADER_SUBTITLE: string = '';

  public headerTitle: string = HeaderComponent.DEFAULT_HEADER_TITLE;
  public headerSubtitle: string = HeaderComponent.DEFAULT_HEADER_SUBTITLE;

  constructor(private store: Store<IRemoteXPACPortalState>) { }

  public ngOnInit(): void {
    this.store.select(selectUserData)
      .pipe(
        filter((value: IUserData | null) => value !== null),
        untilDestroyed(this)
      )
      .subscribe((userData: IUserData) => {
        if (userData.name) {
          if (userData.companyName) {
            this.headerSubtitle = `${userData.name} - ${userData.companyName}`;
          }
          else {
            this.headerSubtitle = userData.name;
          }
        }
        else if (userData.email) {
          this.headerSubtitle = userData.email
        }
      })
  }

}
